var addNotification = (function () {
  const init = function () {
    $("#ValidFromDate")
      .datepicker({ language: "uk" })
      .datepicker("setDate", new Date());
    $("#ValidFromTime").timepicker({
      showMeridian: false,
      minuteStep: 1,
      icons: {
        up: "mdi mdi-chevron-up",
        down: "mdi mdi-chevron-down",
      },
    });

    $("#UsersToAssign")
      .multiselect({
        includeSelectAllOption: true,
        enableClickableOptGroups: true,
        allSelectedText: "всі",
        selectAllText: "Всі користувачі",
        buttonText: function (options, select) {
          if (options.length === 0) {
            return "жодного користувача не обрано";
          } else {
            return "обрано " + options.length + " користувачів";
          }
        },
        widthSynchronizationMode: "always",
        maxHeight: 300,
        buttonWidth: '100%',
      });

    var mdeditor = new SimpleMDE({
      element: document.getElementById("editor"),
      spellChecker: false,
    });
    $("#add-notification-button").on("click", function () {
      const viewModel = {
        ValidFromDate: $("#ValidFromDate").val(),
        ValidFromTime: $("#ValidFromTime").val(),
        TypeId: $("#TypeId").val(),
        Title: $("#Title").val(),
        MarkdownSource: mdeditor.value(),
        UserIdsToAssign: getSelectedUserIds(),
      };

      $.ajax({
        url: "/Notifications/Add",
        method: "POST",
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: JSON.stringify(viewModel),
      }).done(function (data) {
        if (data.success) {
          $.notificationSuccess(data.header, data.message);
          setTimeout(function () {
            location.href = "/Notifications/Index";
          }, reloadDelay);
        } else {
          $.notificationAlert(data.header, data.message);
        }
      });
    });

    function getSelectedUserIds() {
      var selected = "";
      $($("#UsersToAssign option:selected")).each(function (index, type) {
        selected += $(this).val() + ",";
      });
      selected = selected.substring(0, selected.length - 1);
      return selected.split(',');
    }
  };

  return {
    init: init,
  };
})();
